import {
    createElementVNode as _$ce,
    map as _$ma,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Tag} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ma(this.get('tags'), function($value, $key) {
            return _$cc(Tag, {
                'key': $value,
                'type': $value,
                'closable': true,
                'children': $value
            }, $value);
        }, $this),
        _$cc(Tag, {
            'disabled': true,
            'closable': true,
            'children': 'disabled'
        }),
        _$cc(Tag, {
            'closable': true,
            'ev-close': this.prevent,
            'children': 'prevent default'
        })
    ], 0 /* UnknownChildren */);
};